var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main meterial_main" },
            [
              _c("div", { staticClass: "box" }, [
                _c(
                  "div",
                  { staticClass: "tag" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 10 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 20 } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: { change: _vm.typeChange },
                                model: {
                                  value: _vm.type,
                                  callback: function($$v) {
                                    _vm.type = $$v
                                  },
                                  expression: "type"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "type_box" },
                                  [
                                    _c("el-radio-button", {
                                      attrs: { label: "风格" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-radio-button", {
                                      attrs: { label: "空间类型" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-radio-button", {
                                      attrs: { label: "公司案例" }
                                    }),
                                    _vm._v(" "),
                                    _c("el-radio-button", {
                                      attrs: { label: "项目案例" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: { margin: "15px 0 15px" },
                                attrs: {
                                  icon: "el-icon-right",
                                  type: "success"
                                },
                                on: { click: _vm.toPerson }
                              },
                              [
                                _c("span", { staticClass: "btn" }, [
                                  _vm._v("收藏的素材")
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _vm.type == "风格"
                          ? _c(
                              "el-col",
                              { staticClass: "tag_main", attrs: { span: 20 } },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    class: "all_item",
                                    attrs: {
                                      type:
                                        -1 == _vm.styleCur ? "success" : "info",
                                      effect: "light"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.styleClick(-1)
                                      }
                                    }
                                  },
                                  [_vm._v("全部")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.styleData, function(item, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: "style" + index,
                                      attrs: {
                                        type:
                                          index == _vm.styleCur
                                            ? "success"
                                            : "info",
                                        effect: "light"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.styleClick(index)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item.style_type))]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.type == "空间类型"
                          ? _c(
                              "el-col",
                              { staticClass: "tag_main", attrs: { span: 20 } },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    class: "all_item",
                                    attrs: {
                                      type:
                                        -1 == _vm.spaceCur ? "success" : "info",
                                      effect: "light"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.spaceClick(-1)
                                      }
                                    }
                                  },
                                  [_vm._v("全部")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.spaceData, function(item, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: "space" + index,
                                      attrs: {
                                        type:
                                          index == _vm.spaceCur
                                            ? "success"
                                            : "info",
                                        effect: "light"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.spaceClick(index)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item.space_type))]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.type == "公司案例"
                          ? _c(
                              "el-col",
                              { staticClass: "tag_main", attrs: { span: 20 } },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    class: "all_item",
                                    attrs: {
                                      type:
                                        -1 == _vm.companyCur
                                          ? "success"
                                          : "info",
                                      effect: "light"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.companyClick(-1)
                                      }
                                    }
                                  },
                                  [_vm._v("全部")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.companyData, function(item, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: "company" + index,
                                      attrs: {
                                        type:
                                          index == _vm.companyCur
                                            ? "success"
                                            : "info",
                                        effect: "light"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.companyClick(index)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item.project_type))]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.type == "项目案例"
                          ? _c(
                              "el-col",
                              { staticClass: "tag_main", attrs: { span: 20 } },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    class: "all_item",
                                    attrs: {
                                      type:
                                        -1 == _vm.projectCur
                                          ? "success"
                                          : "info",
                                      effect: "light"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.projectClick(-1)
                                      }
                                    }
                                  },
                                  [_vm._v("全部")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.projectData, function(item, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: "project" + index,
                                      attrs: {
                                        type:
                                          index == _vm.projectCur
                                            ? "success"
                                            : "info",
                                        effect: "light"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.projectClick(index)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item.project_type))]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.meterialData.length > 0
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loadType,
                            expression: "loadType"
                          }
                        ],
                        ref: "listBox",
                        staticClass: "list_box"
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "waterfall",
                              {
                                attrs: {
                                  col: 5,
                                  height: "600px",
                                  gutterWidth: 20,
                                  data: _vm.meterialData,
                                  loadDistance: 200
                                },
                                on: {
                                  loadmore: _vm.getMeterial,
                                  scorll: _vm.waterScroll,
                                  finish: _vm.loadFinish
                                }
                              },
                              [
                                _vm._l(_vm.meterialData, function(item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "meterial" + index,
                                      staticClass: "item",
                                      on: {
                                        click: function($event) {
                                          return _vm.toDetail(index)
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            item.photo_url +
                                            "?x-oss-process=image/resize,w_300",
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.type == "公司案例" ||
                                      _vm.type == "项目案例"
                                        ? _c("div", { staticClass: "name" }, [
                                            _vm._v(_vm._s(item.project_name))
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.meterialData.length <= 0
                  ? _c(
                      "div",
                      { staticClass: "list" },
                      [_c("el-empty", { attrs: { description: "暂无数据" } })],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.dialogVisible == "detail_img"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        "custom-class": "pop_img",
                        visible: _vm.dialogVisit,
                        top: "15vh",
                        "show-close": false,
                        center: true,
                        beforeClose: _vm.closeDetail
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _vm.dialogCur != -1
                        ? _c("div", { staticClass: "img" }, [
                            _c("img", {
                              attrs: { src: _vm.dialogImg, alt: "" }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogCur > 0
                        ? _c("div", {
                            staticClass: "arrow left",
                            on: {
                              click: function($event) {
                                return _vm.arrowClick(-1)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.dialogCur < _vm.meterialData.length - 1
                        ? _c("div", {
                            staticClass: "arrow right",
                            on: {
                              click: function($event) {
                                return _vm.arrowClick(1)
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.dialogVisible == "detail"
                ? _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogVisit,
                        top: _vm.dialogTop,
                        width: _vm.dialogWidth,
                        "custom-class": "case-dialog",
                        center: ""
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.dialogVisit = $event
                        }
                      }
                    },
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "detail_box row",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c("el-col", { attrs: { span: _vm.imgColSpan } }, [
                            _vm.dialogCur != -1
                              ? _c("div", { staticClass: "img" }, [
                                  _vm.type == "风格" || _vm.type == "空间类型"
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.detailData.photo_url,
                                          alt: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toDetailImg(
                                              _vm.dialogCur,
                                              1
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.type == "公司案例" ||
                                  _vm.type == "项目案例"
                                    ? _c(
                                        "div",
                                        { staticClass: "swiper-container" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "swiper mySwiper2",
                                              staticStyle: {
                                                "--swiper-navigation-color":
                                                  "#fff",
                                                "--swiper-pagination-color":
                                                  "#fff"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "swiper-wrapper"
                                                },
                                                _vm._l(
                                                  _vm.detailData.photo,
                                                  function(item) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: item.photo_url,
                                                        staticClass:
                                                          "swiper-slide"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: item.photo_url
                                                          },
                                                          on: {
                                                            load:
                                                              _vm.onMainImageLoad
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "swiper-button-next"
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "swiper-button-prev"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "swiper mySwiper",
                                              attrs: { thumbsSlider: "" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "swiper-wrapper"
                                                },
                                                _vm._l(
                                                  _vm.detailData.photo,
                                                  function(item) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: item.photo_url,
                                                        staticClass:
                                                          "swiper-slide"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: item.photo_url
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.dialogCur != -1
                            ? _c(
                                "el-col",
                                { attrs: { span: _vm.infoColSpan } },
                                [
                                  _vm.type == "风格" || _vm.type == "空间类型"
                                    ? _c("div", { staticClass: "list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "item title" },
                                          [_vm._v("基本信息")]
                                        ),
                                        _vm._v(" "),
                                        _vm.detailData.client_name != ""
                                          ? _c("div", { staticClass: "item" }, [
                                              _c(
                                                "div",
                                                { staticClass: "label" },
                                                [_vm._v("客户名称")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "content" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.detailData.client_name
                                                    )
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "item" }, [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("空间类型")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "content" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.detailData.space_type
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "item" }, [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("风格")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "content" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.detailData.style_type
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "item" }, [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("贡献者")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "content" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.detailData.author_name_en
                                                )
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "item" }, [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("上传时间")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "content date" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.detailData.createtime
                                                )
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.type == "公司案例" ||
                                  _vm.type == "项目案例"
                                    ? _c(
                                        "div",
                                        { staticClass: "list" },
                                        [
                                          _vm.type == "项目案例"
                                            ? _c(
                                                "div",
                                                { staticClass: "item title" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.detailData.company
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "item" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.detailData.design_concept
                                                ) +
                                                "\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "div",
                                              { staticClass: "label" },
                                              [_vm._v("项目名称")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.detailData.project_name
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "div",
                                              { staticClass: "label" },
                                              [_vm._v("项目地址")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.detailData
                                                      .project_address
                                                  )
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "div",
                                              { staticClass: "label" },
                                              [_vm._v("项目面积")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.detailData.project_area
                                                  ) + "平方米"
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "div",
                                              { staticClass: "label" },
                                              [_vm._v("标签类型")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              _vm._l(
                                                _vm.detailData.tag,
                                                function(value, index) {
                                                  return _c("span", [
                                                    index ==
                                                    _vm.detailData.tag.length -
                                                      1
                                                      ? _c("span", [
                                                          _vm._v(_vm._s(value))
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    index <
                                                    _vm.detailData.tag.length -
                                                      1
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(value) +
                                                              " / "
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ])
                                                }
                                              ),
                                              0
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "div",
                                              { staticClass: "label" },
                                              [_vm._v("项目类型")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "content date" },
                                              [
                                                Array.isArray(
                                                  _vm.detailData.project_type
                                                )
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detailData.project_type.join(
                                                            " / "
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detailData
                                                            .project_type
                                                        )
                                                      )
                                                    ])
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.type == "项目案例"
                                            ? _c(
                                                "div",
                                                { staticClass: "item" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "label" },
                                                    [_vm._v("设计师")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "content date"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.detailData
                                                            .designer
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "success" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.toGenerate(
                                                    _vm.dialogCur
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("应用同款")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.type == "风格" || _vm.type == "空间类型"
                        ? _c(
                            "span",
                            {
                              staticClass: "dialog-footer",
                              attrs: { slot: "footer" },
                              slot: "footer"
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.toGenerate(_vm.dialogCur)
                                    }
                                  }
                                },
                                [_vm._v("生成同款")]
                              ),
                              _vm._v(" "),
                              _vm.dialogCur >= 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.toCollect(_vm.dialogCur)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.detailData.user_material_id == 0
                                            ? "收藏"
                                            : "取消收藏"
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d3d8584", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d3d8584","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Material/Index.vue
// module id = null
// module chunks = 